<div class="mentions-block">
    <app-project-alert  *ngFor="let alert of alertsList" [projectAlert]="alert" [alertsOP]="alertsOP"></app-project-alert>
</div>

<div class="nf-footer">
    <div class="nf-other" *ngIf="alertsList.length > 0" [routerLink]="['/alerts']" (click)="openNFPage()">
        View all alerts
    </div>
    <div class="nf-other" *ngIf="alertsList.length === 0" [routerLink]="['/alerts']" (click)="openNFPage()">
        No new alerts
    </div>
</div>